import { useEffect, useState } from "react";
// import Slider from "react-slick";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y } from "swiper/modules";

import { useDispatch, useSelector } from "react-redux";
import ormCalculations from "../../../hooks/api/calculate";
import ORMfunctions from "../../../hooks/app/general";
import { type RootState } from "../../../store/store";
import {
  setPriceLoading,
  setPriceSuccess,
  setPriceError,
} from "../../../store/orm/userSession";

import { convertCurrency } from "../../../utils/formater";
import CalcTariff from "../vehicle/CalcTariff";
import Equipments from "../vehicle/Equipments";

export function Tariff({
  vehicle,
  tariffs,
  leadtime,
  interval,
  stationpreset,
  setShowModal,
}: {
  vehicle: any;
  tariffs: any;
  leadtime: any;
  interval: any;
  stationpreset: any;
  setShowModal: (bool: boolean) => void;
}) {
  const [errorCount, setErrorCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  function sizeImg(img: string, size = 800) {
    return img.replace(/\/original\//g, `/${size}/`);
  }

  const handleTariffError = (vehicleId: string, tariffType: string) => {
    // console.log("Tariff error:", vehicleId, tariffType);
    setErrorCount((prev) => {
      const newCount = prev + 1;
      // console.log("Error count updated:", newCount);
      return newCount;
    });
  };

  const handleTariffSuccess = (vehicleId: string, tariffType: string) => {
    // console.log("Tariff success:", vehicleId, tariffType);
    setSuccessCount((prev) => {
      const newCount = prev + 1;
      // console.log("Success count updated:", newCount);
      return newCount;
    });
  };

  // Effekt um Sichtbarkeit zu berechnen
  useEffect(() => {
    const totalCalculations = errorCount + successCount;

    // console.log("UseEffect triggered:", {
    //   errorCount,
    //   successCount,
    //   totalCalculations,
    //   tariffsLength: tariffs.length,
    //   vehicleId: vehicle.id,
    // });

    // Prüfen ob alle Tarife durchgerechnet wurden
    if (totalCalculations >= tariffs.length && tariffs.length > 0) {
      // Ausblenden wenn zu viele Fehler (mindestens 2 Erfolge nötig bei mehreren Tarifen)
      const shouldBeVisible =
        successCount >= 2 || (tariffs.length === 1 && successCount === 1);

      // console.log("Calculations complete:", {
      //   vehicle: vehicle.id,
      //   total: totalCalculations,
      //   errors: errorCount,
      //   success: successCount,
      //   shouldBeVisible,
      // });

      setIsVisible(shouldBeVisible);
    }
  }, [errorCount, successCount, tariffs.length]);

  // Nicht rendern wenn nicht sichtbar und Berechnungen durch sind
  if (!isVisible && errorCount + successCount >= tariffs.length) {
    // console.log("Component hidden:", vehicle.id);
    return null;
  }

  return (
    <article key={vehicle.id} className={`orm-tariff-card`}>
      <div className="orm-tariff-card__main">
        <div className="orm-tariff-card__slider">
          <Swiper
            pagination={{
              clickable: true,
            }}
            spaceBetween={0}
            loop={true}
            modules={[Pagination, A11y]}
            navigation={false}
            a11y={true}
            autoHeight={false}
          >
            {vehicle.images.map((img: any, i: any) => (
              <SwiperSlide key={i} className="orm-tariff-card__slider-coverImg">
                <img src={sizeImg(img.image, 900)} alt={vehicle.text_web} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="orm-tariff-card__content">
          <h3 className="orm-headline__h2">{vehicle.text_web}</h3>

          <p className="orm-headline__h2__subheadline orm-mb-8 orm-relative">
            <span
              dangerouslySetInnerHTML={{
                __html: vehicle.description_web || "",
              }}
            ></span>
            <i
              className="fal fa-question-circle orm-cargroup__tooltip"
              tabIndex={0}
              role="button"
              aria-label={ORMfunctions.i18n("cargroup/noguarantee")}
            >
              <span
                className="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom"
                role="tooltip"
              >
                {ORMfunctions.i18n("cargroup/noguarantee")}
              </span>
            </i>
          </p>

          <Equipments features={vehicle.features} />
        </div>
      </div>
      <div className="orm-tariff-card__footer">
        {tariffs.map((tariff: any) => (
          <CalcTariff
            key={tariff.type}
            id={vehicle.id}
            vehicle={vehicle}
            options={{ tariff, leadtime, interval, stationpreset }}
            error={(tariffType: string) => {
              handleTariffError(vehicle.id, tariffType);
            }}
            success={(tariffType: string) => {
              handleTariffSuccess(vehicle.id, tariffType);
            }}
            setShowModal={() => setShowModal(true)}
          />
        ))}
      </div>
    </article>
  );
}

export default Tariff;
